import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Utils } from 'src/app/common/utils';
import { Physician } from 'src/app/models/physician';
import { VproService } from 'src/app/service/vpro/vpro.service';
import Swal from 'sweetalert2';
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

@Component({
  selector: 'app-consultation-summary',
  templateUrl: './consultation-summary.component.html',
  styleUrls: ['./consultation-summary.component.css']
})
export class ConsultationSummaryComponent implements OnInit {
  aptForm: UntypedFormGroup;
  consultationReport: any;
  prescription: any;
  physician: Physician;
  physician_model: any = {};
  specialitiesList: any = [];
  states: any = [];
  dateFormat = Utils.DATE_FORMAT;
  defaultDr = Utils.DEFAULTDR;
  constructor(private route: ActivatedRoute, private _formBuilder: UntypedFormBuilder, private service: VproService, private spinner: NgxSpinnerService, private router: Router, private utils: Utils) { }

  ngOnInit() {
    this.aptForm = this._formBuilder.group({
      aptid: [this.route.snapshot.params['aid'], Validators.required],
      passcode: ['', Validators.required]
    });
    this.checkIfUserHasAccess();
  }

  checkIfUserHasAccess() {
    if (localStorage.getItem('uid') && localStorage.getItem('LogUsrTyp')) {
      // check if logged in user is a physician or patient
      if (this.utils.checkRoutesAccess(JSON.parse(localStorage.getItem('LogUsrTyp')), [2, 4])) {
        this.submit();
      }
    }
  }

  submit() {
    let { aptid, passcode } = this.aptForm.value;
    this.spinner.show();
    let data = { aptid: aptid, passcode: passcode };
    if (localStorage.getItem('uid')) data['uid'] = JSON.parse(localStorage.getItem('uid'));

    this.service.getPrescription(data).subscribe(res => {
      this.spinner.hide();
      this.consultationReport = res;
      if (res && res.prescription) {
        this.prescription = res.prescription[0].json_agg;
      }
      if (res && res.physician) {
        this.physician = res.physician[0];
      }

      if (this.physician && this.physician.physician_qualification && this.physician.physician_qualification.length) {
        this.physician.qualification = this.physician.physician_qualification[0].qualification;
      }

      if (this.physician && this.physician.physician_education && this.physician.physician_education.length) {
        this.physician_model.education = this.physician.physician_education.map(x => x.degree).join(", ");
        this.physician_model.university = this.physician.physician_education.map(x => x.institution).join(", ");
      }

      if (this.physician && this.physician.physician_speciality && this.physician.physician_speciality.length) {
        this.getSpecialitiesList();
      }

      if (this.physician && this.physician.state) {
        this.loadStates();
      }

    }, error => {
      // console.log(error)
      this.spinner.hide();
      let msg = error && error.error && error.error.message ? error.error.message : "Something went wrong. Please try again."
      this.showToast('error', msg);
    })
  }

  getSpecialitiesList() {
    this.spinner.show();
    this.service.getSpecialitiesList().subscribe(
      (res) => {
        this.spinner.hide();
        this.specialitiesList = res;
        //Map Specialities
        let specialities = [];
        this.physician.physician_speciality.forEach(element => {
          let sp = this.specialitiesList.find(s => s.id == element.speciality_id)
          specialities.push(`${sp.name} - ${element.no_of_years}Years`)
        });
        this.physician_model.speciality = specialities.join(', ');
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  loadStates() {
    this.service.getStates(1).subscribe((res) => {
      this.states = res;
      this.physician_model.location = this.states.find(x => x.id == this.physician.state)
      this.physician_model.location = ", " + this.physician_model.location.name;
    });
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title
    });
  }

  gotoPage() {
    this.router.navigate([`/feedback`], { queryParams: { drid: this.physician.u_id, aptid: this.consultationReport.aptid } });
  }

}
